<script setup>
import { stateManager } from '@/stateManager';
import { useRoute, useRouter } from 'vue-router';
const router = useRouter();
const route = useRoute();

  function sideNavOpen() {
      document.getElementById('sideNav').style.width = "285px";
      document.getElementById('bodyOverlay').style.height = "100%";
      document.getElementById('bodyOverlay').style.opacity = "1";

      // overlay on the searchabar not work, this is a bug fix
      // document.getElementById('hideOnMenuOpen_issue').style.opacity = "0.05"; 
      document.body.style.overflow = 'hidden';
  }

  function goHome() {
      if (route.name != 'home') 
        router.push({ name: "home" });
  }
</script>

<template>
        <div class="navbar-logo">
          <!-- menu icon -->
          <span class="sideNav-openButton" v-on:click="sideNavOpen()">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
            </svg>
          </span>

           <!-- logo -->
          <img src="@/assets/img/logo.png" @click="goHome" :class="[{ animationShow_logo: stateManager.animationEnabled }, { notActive: stateManager.isSearchInputActive }]">
          <h1 @click="goHome" :class="[{ animationShow_logo: stateManager.animationEnabled }, { notActive: stateManager.isSearchInputActive }]">Salmi<span></span>Biblici</h1>
        </div>
</template>